const LABELS = { min: 'Minimum', max: 'Maximum', free: 'Free' };

/**
 * Validates a modifier group's Minimum / Maximum / Free. Empty means not set,
 * and a Maximum of 0 means unlimited (same as the POS preview).
 * Returns an error message, or null when the combination is valid.
 */
export const validateSelectionLimits = ({ min, max, free }) => {
  const values = { min, max, free };
  for (const key of Object.keys(values)) {
    const value = values[key];
    if (value === null || value === undefined) continue;
    if (!Number.isInteger(value) || value < 0) {
      return `${LABELS[key]} must be a whole number of 0 or more`;
    }
  }
  if (max > 0) {
    if (min > max) return 'Minimum can’t be greater than Maximum';
    if (free > max) return 'Free can’t be greater than Maximum';
  }
  return null;
};
